import { createFileRoute } from '@tanstack/react-router';
import { SignInGooglePage } from '@/pages/sign-in-google';
import { authGuardRoute } from '@/features/authenticate';

export const Route = createFileRoute('/_public/auth/callback')({
  beforeLoad: () => authGuardRoute({ isPrivate: false }),
  component: SignInGooglePage,
});
